import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

/* Kia OEM tier identity — consumed via CSS tokens defined in index.css */
export const TIER_TOKENS = {
  Platinum: "--tier-platinum",
  Gold: "--tier-gold",
  Silver: "--tier-silver",
  Bronze: "--tier-bronze",
  Focus: "--tier-focus",
};

export const tierVar = (tier) => TIER_TOKENS[tier] || "--cx-slate";

export const TierBadge = ({ tier, className, testId }) => {
  if (!tier) return <span className="text-xs text-muted-foreground">—</span>;
  const v = tierVar(tier);
  return (
    <Badge variant="outline"
      className={cn("text-[0.62rem] font-semibold uppercase tracking-wide border", className)}
      style={{
        color: `hsl(var(${v}))`,
        borderColor: `hsl(var(${v}) / 0.45)`,
        backgroundColor: `hsl(var(${v}) / 0.08)`,
      }}
      data-testid={testId}>
      {tier}
    </Badge>
  );
};

export const EvalDot = ({ evalColor, testId }) => {
  const map = {
    green: "bg-[hsl(var(--status-green))]",
    amber: "bg-[hsl(var(--status-amber))]",
    red: "bg-[hsl(var(--cx-crimson))]",
  };
  return (
    <span className={cn("inline-block w-2 h-2 rounded-full align-middle",
      map[evalColor] || "bg-[hsl(var(--cx-slate)/0.35)]")}
      aria-label={evalColor || "n/a"} data-testid={testId} />
  );
};

/* MoM movement: score up = good; rank deltas passed pre-normalised (positive = improved) */
export const MomDelta = ({ value, suffix = "", invertColors = false, testId }) => {
  if (value === null || value === undefined) {
    return <span className="text-xs text-muted-foreground">—</span>;
  }
  const good = invertColors ? value < 0 : value > 0;
  if (value === 0) return <span className="text-xs text-muted-foreground tabular">0{suffix}</span>;
  return (
    <span className={cn("text-xs font-semibold tabular",
      good ? "text-[hsl(var(--status-green))]" : "text-[hsl(var(--cx-crimson))]")}
      data-testid={testId}>
      {value > 0 ? "\u25b2" : "\u25bc"} {Math.abs(value)}{suffix}
    </span>
  );
};
